import React, { useEffect, useState, useCallback } from "react";
import InfoWithImageSection from "../UI/InfoWithImageSection";
import CardModel from "./CardModel";
import styles from "@/styles/desktop/Machine.module.scss";
import GallerySlide from "../UI/GallerySlide";
import FreemodeSlide from "../UI/FreemodeSlide";
import { MachineProps } from "@/app/interface/components";

const MachineDesktop: React.FC<MachineProps> = ({ model, modelData }) => {
	const [imgs, setImgs] = useState<string[]>([]);

	useEffect(() => {
		const fetchImages = async () => {
			const galleryBasePath = `https://gabcomercio.azureedge.net/azul-agro/desktop/machines/${modelData.machine}/${model}/gallery`;
			const imageUrls = [];
			let index = 1;

			while (index <= modelData.imgs) {
				const imageUrl = `${galleryBasePath}/img-${index}.webp`;
				imageUrls.push(imageUrl);
				index++;
			}

			setImgs(imageUrls);
		};

		fetchImages();
	}, [model, modelData]);

	return (
		<main>
			<InfoWithImageSection
				isIntro
				title={model
					.replace(/-/g, " ")
					.replace("cana de acucar", "cana-de-açúcar")}
				text={modelData.introSection}
				img={`https://gabcomercio.azureedge.net/azul-agro/desktop/machines/${modelData.machine}/${model}/product.webp`}
				imgHeightFixed
				width={944}
				height={944}
				hasButton
				href={`/contato?machine=${modelData.machine}&model=${model}`}
			/>

			{modelData.about?.[0] && (
				<InfoWithImageSection
					justifyContent={"flex-end"}
					isDropdown
					title={`Sobre ${model}`}
					contentDropdown={modelData.about}
					img={`https://gabcomercio.azureedge.net/azul-agro/desktop/machines/${modelData.machine}/${model}/about.webp`}
					imgHeightFixed
					width={944}
					height={944}
					text={""}
					loading={"lazy"}
				/>
			)}

			{modelData.differences?.[0] && (
				<InfoWithImageSection
					justifyContent={"flex-start"}
					isDropdown
					title={"Diferenciais"}
					contentDropdown={modelData.differences}
					img={`https://gabcomercio.azureedge.net/azul-agro/desktop/machines/${modelData.machine}/${model}/difference.webp`}
					imgHeightFixed
					width={960}
					height={800}
					text={""}
					flexDirection="row-reverse"
					loading={"lazy"}
				/>
			)}

			<section className={styles.models}>
				<h2 className="h2-medium">Modelos</h2>
				<div>
					<FreemodeSlide gap="16px" padding="0px 16px">
						{modelData.subModels.map((subModel: any, index: number) =>
							subModel.content.map((name: string) => (
								<CardModel
									key={name}
									name={name}
									img={`https://gabcomercio.azureedge.net/azul-agro/desktop/machines/${
										modelData.machine
									}/${model}/models/model-${index + 1}.webp`}
									href={`/${subModel.pdf}`}
								/>
							))
						)}
					</FreemodeSlide>
				</div>
			</section>

			{imgs.length > 0 && (
				<section
					style={{
						overflow: "hidden",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						gap: "24px",
						padding: "60px 0",
					}}
				>
					<h2 className="h2-medium">Galeria</h2>
					<GallerySlide imgs={imgs} width={695} height={440} isDesktop />
				</section>
			)}
		</main>
	);
};

export default React.memo(MachineDesktop);
